// clients
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const GET_CLIENTS_FAILURE = 'GET_CLIENTS_FAILURE';
export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST';
export const CLEAR_CLIENTS = 'CLEAR_CLIENTS';

// client
export const SELECT_CLIENT = 'SELECT_CLIENT';
export const CLEAR_SELECTED_CLIENT = 'CLEAR_SELECTED_CLIENT';

// vehicles
export const GET_CLIENT_VEHICLES_SUCCESS = 'GET_CLIENT_VEHICLES_SUCCESS';
export const GET_CLIENT_VEHICLES_FAILURE = 'GET_CLIENT_VEHICLES_FAILURE';
export const GET_CLIENT_VEHICLES_REQUEST = 'GET_CLIENT_VEHICLES_REQUEST';
export const CLEAR_CLIENT_VEHICLES = 'CLEAR_CLIENT_VEHICLES';

// pagination
export const SET_CLIENTS_SEARCH = 'SET_CLIENTS_SEARCH';
export const SET_CLIENTS_PAGE_SIZE = 'SET_CLIENTS_PAGE_SIZE';
export const NEXT_CLIENTS_PAGE = 'NEXT_CLIENTS_PAGE';
export const PREV_CLIENTS_PAGE = 'PREV_CLIENTS_PAGE';
